export default "__VITE_ASSET__DSnXHfcH__"